import React from 'react';
import styled from 'styled-components';
import { CustomTooltip } from '../../../../general_components/content_management/reusableItems/tooltips';
import { DateTime } from "luxon";
import { API_ROOT, sendRequest } from '../../../../supplementary_components/requests';
import { useBoardStore } from '../../../boardStore';

const TruckState = styled.div`
    cursor:pointer;
    &>span{
        &.TOO_LONG_STATIONARY{
            background:var(--alert-background);
            color: var(--alert-color);
        }
        &.On{
            background-color:rgba(var(--successGreenRGB), 0.3);
            color: rgb(var(--successGreenRGB));
        }
        &.Off{
            background-color:var(--extra-light-gray);
            color: var(--light-gray);
        }
        &.Idle{
            background-color:rgba(var(--inProgressYellowRGB), 0.3);
            color: rgb(var(--inProgressYellowRGB));
            font-size:0.8rem;
            padding: 0.2rem 0.3rem;
        }
        &.none{
            color:var(--dark-gray);
        }
        &:not(.Idle){
            padding: 0.2rem 0.4rem;
        }
        border-radius:0.4rem;
        font-weight:600;
    }
        :hover {
        .tooltip{
            visibility: visible;
            // display:flex;
            transition-property: visibility;
            transition-delay: 0.7s;
        }
    }
`  
// &:not(:first-child){
//     
// }
// <span>
// D
// </span>

export const MB_TRUCK_STATE = ({status, truckData, timeRef}) => {
    const truckIsOnALoad = status ? status.textVal === "Covered" : false;
    let currentState = null;
    let timeInThisState = null;
    let formattedTimeData = null;
    if(truckData.currentEngineState){
        const arr = truckData.currentEngineState.split("|");
        currentState = arr[0];
        timeInThisState = arr[1];
        const now = timeRef?.current || useBoardStore.getState().getLiveCurrentTime?.();
        if (now) {
            formattedTimeData = getFormattedTimePassed(timeInThisState, now);
        }
    }
    return <TruckState className='lblValue' data-timestamp={timeInThisState || ""} 
    // onMouseEnter={(e)=>{
    //         const clsName = e.target.className;
    //         if(clsName === "On" || clsName === "Off" || clsName === "Idle" || clsName.includes("lblValue")){
    //             try {
    //                 const parentNode = clsName.includes("lblValue") ?  e.target : e.target.parentNode;
    //                 const timeVal = parentNode.getAttribute("data-timestamp");
    //                 if(timeVal !== ""){
    //                     parentNode.querySelector(".tooltipContentText").innerText = getFormattedTimePassed(timeVal, timeRef.current || DateTime.now()).lbl;
    //                 }
    //             } catch (error) {
    //             }
    //         }
    //     }}
            onClick={()=>{
                sendRequest("POST", API_ROOT+"trucks/"+truckData.id+"/refresh-location", null, ()=>{}, ()=>{});
                
            }}
        >
        <span className={currentState === "Off" && truckIsOnALoad && formattedTimeData && formattedTimeData.totalMinutes > 40 ? "TOO_LONG_STATIONARY" : (currentState || "none") } >
            
            {!currentState ? "-" : currentState === "Off" ? "S" : "D"}
        </span>
        {formattedTimeData ? 
        <CustomTooltip info={formattedTimeData.lbl || formattedTimeData} marginTop={"0.9rem"} xDisposition="-2rem" />
        :null
        }
        
    </TruckState>
}
export function getFormattedTimePassed(pastTimestampISO, currentTime) {
    // Always work in UTC for diff clarity
    const past = DateTime.fromISO(pastTimestampISO, { zone: 'utc' });
    const now = currentTime.toUTC();
  
    // If past is in the future, clamp at 0 (optional)
    const ms = Math.max(0, now.diff(past, 'milliseconds').milliseconds);
  
    // Threshold: 48 hours
    const fortyEightHoursMs = 48 * 60 * 60 * 1000;
    if (ms > fortyEightHoursMs) {
      return `Since ${past.toFormat('MM/dd/yy')}`;
    }
  
    const totalMinutes = Math.floor(ms / (60 * 1000)); // floor to avoid 60m rollover
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    if (hours > 0) {
      return {lbl: `For ${hours}h ${minutes}m`, totalMinutes: totalMinutes};
    }
    return  {lbl: `For ${minutes}m`, totalMinutes: totalMinutes};
  }